import React, { useCallback, useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, Mail, RefreshCw } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";

const KINDS = [["", "Tutte le comunicazioni"], ["sollecito", "Solleciti incassi"], ["report_cantiere", "Report cantiere"],
  ["invito", "Inviti collaboratori"], ["digest", "Riepiloghi scadenze"], ["sollecito_interno", "Solleciti interni"],
  ["reset_password", "Reimposta password"], ["abbonamento", "Abbonamento"]];
const stamp = value => String(value || "").slice(0, 16).replace("T", " alle ");

export const EmailLogPanel = () => {
  const [kind, setKind] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setBusy(true); setError("");
    try { setData(await practiceApi(`/email-log?limit=100${kind ? `&kind=${kind}` : ""}`)); }
    catch (err) { setError(err.message); } finally { setBusy(false); }
  }, [kind]);
  useEffect(() => { load(); }, [load]);

  const rows = data?.rows || [];
  return <section className="receivables-card" data-testid="email-log-panel">
    <header>
      <div>
        <span className="finance-kicker"><Mail size={13} />REGISTRO INVII</span>
        <h2>Comunicazioni inviate</h2>
      </div>
      <div className="email-log-tools">
        <label className="receivables-filter">Tipo
          <select value={kind} data-testid="email-log-kind" onChange={e => setKind(e.target.value)}>
            {KINDS.map(([value, label]) => <option key={value || "all"} value={value}>{label}</option>)}
          </select>
        </label>
        <button className="icon-btn" title="Aggiorna il registro" data-testid="email-log-refresh" disabled={busy} onClick={load}><RefreshCw size={14} /></button>
      </div>
    </header>
    {error && <div className="error" role="alert" data-testid="email-log-error">{error}</div>}
    <div className="receivables-total" data-testid="email-log-summary">
      <span>{data?.total || 0} comunicazioni registrate</span>
      <strong>{data?.sent || 0} inviate · {data?.failed || 0} non riuscite</strong>
    </div>
    <div className="data-table">
      <div className="table-head" style={{ gridTemplateColumns: "1.1fr 1.3fr 1.6fr 1fr .9fr" }}>
        <span>Tipo</span><span>Destinatario</span><span>Oggetto</span><span>Data</span><span>Esito</span>
      </div>
      {rows.map((row, index) => <div className="table-row" key={row.provider_id || `${row.sent_at}-${index}`}
        data-testid={`email-log-row-${index}`} style={{ gridTemplateColumns: "1.1fr 1.3fr 1.6fr 1fr .9fr" }}>
        <span><strong>{row.label || "Comunicazione"}</strong>{row.client_name ? <small className="receivables-practices">{row.client_name}</small> : null}</span>
        <span>{row.to}{row.by_user_name ? <small className="receivables-practices">inviata da {row.by_user_name}</small> : null}</span>
        <span>{row.subject}</span>
        <span>{stamp(row.sent_at)}</span>
        <span className={row.status === "inviata" ? "email-state ok" : "email-state ko"} data-testid={`email-log-status-${index}`}>
          {row.status === "inviata" ? <><CheckCircle2 size={13} />Inviata</> : <><AlertTriangle size={13} />{row.error || "Errore"}</>}
        </span>
      </div>)}
      {!rows.length && !busy && <p className="muted" data-testid="email-log-empty">Nessuna comunicazione inviata con questo filtro.</p>}
    </div>
  </section>;
};
